import { render, staticRenderFns } from "./bodyEndurance.vue?vue&type=template&id=8a481164&scoped=true"
import script from "./bodyEndurance.vue?vue&type=script&lang=js"
export * from "./bodyEndurance.vue?vue&type=script&lang=js"
import style0 from "./bodyEndurance.vue?vue&type=style&index=0&id=8a481164&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a481164",
  null
  
)

export default component.exports